import React from 'react';

import _ from 'lodash';

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';
import InputTextField from '../../Fields/InputTextField';
import InputSelectField from '../../Fields/InputSelectField';
import InputRadioGroupField from '../../Fields/InputRadioGroupField';
import FeeTable from '../../Fields/FeeTable';
import AccessDeviceTable from '../../Fields/AccessDeviceTable';


class RateDetailFeesPanel extends React.Component {
  _onFeeChange(type) {
    return (ident, value) => {
      const fees = _.cloneDeep(this.props.rate.fields.fees);

      if (ident === null) ident = fees[type].value.length;

      fees[type].value[ident] = value;

      this._onInputChange('fees')(fees);
    };
  }


  _onAccessDeviceChange = (ident, value) => {
    const accessDevices = _.cloneDeep(this.props.rate.fields.access_devices.value);

    if (ident === null) ident = accessDevices.length;

    if (value === null) {
      accessDevices.splice(ident, 1);
    }
    else {
      accessDevices[ident] = value;
    }

    this._onInputChange('access_devices')(accessDevices);
  }


  _onInputChange(inputId) {
    return value => {
      switch (inputId) {
        case 'lost_device_request':
          if (value !== null) value = (value === 'true') ? true : false;
          break;
        default:
      }

      this.props.onValueChange(inputId, value);
    };
  }


  render() {
    const {
      rate,
      newMode,
      editMode,
      fieldConfiguration,
      billingProfiles
    } = this.props;

    const {
      rate: rateFieldConfiguration,
      accessDevice: accessDeviceFieldConfiguration
    } = fieldConfiguration;

    const requiredFieldState = (newMode || editMode);

    const activationFeeTableRows = rate.fields.fees.activation.value.map((fee, index) => {
      return { ident: index, data: fee };
    });
    const lostDeviceFeeTableRows = rate.fields.fees.lost_device.value.map((fee, index) => {
      return { ident: index, data: fee };
    });
    const creditCardFeeTableRows = rate.fields.fees.credit_card.value.map((fee, index) => {
      return { ident: index, data: fee };
    });
    const lateFeeTableRows = rate.fields.fees.late.value.map((fee, index) => {
      return { ident: index, data: fee };
    });

    const accessDeviceTableRows = rate.fields.access_devices.value.map((accessDevice, index) => {
      return { ident: index, data: accessDevice };
    });

    return (
      <div>
        <FieldGroup label="Activation Fee">
          <Field layout="stacked">
            <FeeTable inputId="parkchirp--rate--activation-fee"
              feeRows={activationFeeTableRows}
              feeType="ACTIVATION"
              onFeeChange={this._onFeeChange('activation')}
              allowAdd={(newMode || editMode)}
              editMode={(newMode || editMode)}
            />
          </Field>
        </FieldGroup>
        <FieldGroup label="Access Devices">
          <Field>
            <AccessDeviceTable inputId="parkchirp--rate--access-devices"
              accessDeviceRows={accessDeviceTableRows}
              onAccessDeviceChange={this._onAccessDeviceChange}
              fieldConfiguration={accessDeviceFieldConfiguration}
              editMode={(newMode || editMode)}
              allowAdd={(newMode || editMode)}
            />
          </Field>
          <Field label="Access Device Message"
            id="parkchirp--rate--access-device-message"
            layout="stacked">
            <InputTextField inputId="parkchirp--rate--access-device-message"
              value={rate.fields.access_device_message.value}
              onChange={this._onInputChange('access_device_message')}
              editMode={newMode || editMode}
              multiLine={true}
            />
          </Field>
        </FieldGroup>
        <FieldGroup label="Lost Devices">
          <Field label="Lost Device Request"
            id="parkchirp--rate--lost-device-request"
            required={requiredFieldState}
            layout="columns">
            <InputRadioGroupField inputId="parkchirp--rate--lost-device-request"
              options={rateFieldConfiguration.lost_device_request.options}
              value={rate.fields.lost_device_request.value}
              onChange={this._onInputChange('lost_device_request')}
              editMode={newMode || editMode}
            />
          </Field>
          <Field layout="stacked">
            <FeeTable inputId="parkchirp--rate--lost-device-fee"
              feeRows={lostDeviceFeeTableRows}
              feeType="LOST_DEVICE"
              onFeeChange={this._onFeeChange('lost_device')}
              allowAdd={(newMode || editMode)}
              editMode={(newMode || editMode)}
            />
          </Field>
        </FieldGroup>
        <FieldGroup label="Credit Card Fee">
          <Field layout="stacked">
            <FeeTable inputId="parkchirp--rate--credit-card-fee"
              feeRows={creditCardFeeTableRows}
              feeType="CREDIT_CARD"
              onFeeChange={this._onFeeChange('credit_card')}
              allowAdd={(newMode || editMode)}
              editMode={(newMode || editMode)}
            />
          </Field>
        </FieldGroup>
      </div>
    );
  }
}
export default RateDetailFeesPanel;
